<template>
  <div class="card is-min-width-700" v-if="payload">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3" v-if="evenement">
            {{ $t('addEditPlanMedia.evenement.titleEdit') }}
          </h1>
          <h1 class="title is-size-3" v-else>
            {{ $t('addEditPlanMedia.evenement.titleAdd') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field
          :label="$t('addEditPlanMedia.evenement.information.dateEvenement')"
          class="obligatoire column is-4 mgb-0">
          <div class="columns is-vcentered" >
            <b-datepicker
              v-model="payload.dateEvenement"
              class="column"
              icon="calendar-today"
              position="is-bottom-right"
              editable
              nearby-selectable-month-days
              show-week-number>
            </b-datepicker>
          </div>
        </b-field>
        <user-selector
          v-model="payload.commercialId"
          :label="$t('addEditPlanMedia.evenement.information.gestionnaire')"
          class="column is-4 mgb-0"
          obligatoire
        />
        <parametre-autocomplete
          :label="$t('addEditPlanMedia.evenement.information.type')"
          class="column is-4 mgb-0"
          v-model="payload.typeId"
          :target="constantes.PARAMETRES_KEYS.typeEvenement"
          expanded
          required
        />
        <b-field
          :label="$t('addEditPlanMedia.evenement.information.descriptif')"
          class="column is-6 mgb-0">
          <b-input v-model="payload.descriptif" type="textarea" rows="4"/>
        </b-field>
        <b-field
          :label="$t('addEditPlanMedia.evenement.information.ventes')"
          class="column is-6 mgb-0">
          <b-input v-model="payload.ventes" type="textarea" rows="4"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import genererEvenement from '@/services/planMedia/genererEvenement';
import userSelector from '@/components/commun/user/userSelector';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    evenement: {
      type: Object,
      required: false,
    },
    planMedia: {
      type: Object,
      required: true,
    },
  },
  components: {
    userSelector,
    ParametreAutocomplete,
  },
  data() {
    return {
      payload: null,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    save() {
      if (this.evenement) {
        const index = this.planMedia.evenements.findIndex(e => e.id === this.evenement.id);
        if (index !== -1) {
          this.planMedia.evenements.splice(index, 1, this.payload);
        }
      } else {
        this.planMedia.evenements.push(this.payload);
      }
      this.$parent.close();
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.payload = this.evenement ? cloneDeep(this.evenement) : genererEvenement();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
